import { PaymentDetailsLegalEntityType } from 'shared/data/webApp/v2';

import { messages } from './SecondStep.messages';

export const legalEntityTypes = [
    {
        id: PaymentDetailsLegalEntityType.Individual,
        name: messages.individual,
    },
    {
        id: PaymentDetailsLegalEntityType.Company,
        name: messages.company,
    },
];
